import { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import {
  Box,
  Typography,
  Button,
  Link
} from '@mui/material'
import Home from './pages/home.js'
import Bookmark from './pages/bookmark.js'
import Profile from './pages/profile.js'
import Courses from './pages/courses.js'
import ManageCourses from './pages/manage-courses.js'
import Course from './pages/course.js'
import CollectionBasic from './pages/collectionBasic.js'
import CollectionIntermediate from './pages/collectionIntermediate.js'
import CollectionAdvanced from './pages/collectionAdvanced.js'
import PageLayout from './pages/pageLayout'
import { useAuth0 } from '@auth0/auth0-react'
import GlobalLoader from './components/GlobalLoader.js'
import ReactGA from 'react-ga4'
import RequireAuth from './auth/RequireAuth'
import CourseEditorPage from './pages/CourseEditorPage';

ReactGA.initialize('G-2M32EMYY67', {
  testMode: (process.env.REACT_APP_BUILD_ENV || 'development') === 'development',
})

// Custom component to handle free course access
const CourseAccessHandler = ({ component }) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth0();
  
  // Check if the current path is for the free course
  const isFreeCourse = location.pathname.includes('getting-started-with-qallix');
  
  // If it's the free course, render it without authentication requirement
  if (isFreeCourse) {
    return component;
  }
  
  // For other courses, require authentication
  return <RequireAuth component={component} />;
};

function App() {
  const { isLoading } = useAuth0()
  const location = useLocation()

  useEffect(() => {
    const handleWheel = () => {
      if (document.activeElement?.type === 'number') {
        document.activeElement.blur()
      }
    }

    document.addEventListener('wheel', handleWheel)
    return () => document.removeEventListener('wheel', handleWheel)
  }, [])

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
    })
  }, [location])

  if (isLoading) {
    return <GlobalLoader />
  }

  return (
    <>
      <Routes>
        {/*public (no authentication required) */}
        <Route element={<PageLayout authRequired={false} />}>
          <Route path="/" element={<Home />} />
          <Route path='/courses' element={<Courses />} />
          <Route path='/collection-basic' element={<CollectionBasic />} />
          <Route path='/collection-intermediate' element={<CollectionIntermediate />} />
          <Route path='/collection-advanced' element={<CollectionAdvanced />} />
          
          {/* Free course route - no authentication required */}
          <Route
            path="/courses/getting-started-with-qallix"
            element={<Course />}
          />
        </Route>

        {/* Private (authentication required) */}
        <Route element={<PageLayout authRequired={true} footer={false} />}>
          <Route
            path="/courses/:slug"
            element={<CourseAccessHandler component={<Course />} />}
          />
          <Route
            path="/profile"
            element={<RequireAuth component={<Profile />} />}
          />
          {/* <Route
            path="/bookmark"
            element={<RequireAuth component={<Bookmark />} />}
          /> */}
          <Route
            path="/manage-courses"
            element={<RequireAuth component={<ManageCourses />} roles={['IT', 'SuperAdmin']} org={['wistech']} />}
          />
          <Route
            path='/manage-courses/:courseId/course-info'
            element={<RequireAuth component={<CourseEditorPage />} roles={['IT', 'SuperAdmin']} org={['wistech']} />}
          />
        </Route>
      </Routes>
    </>
  )
}

export default App